export default {
  mutations: {
    UPDATE_DATA: 'UPDATE_DATA'
  },
  getters: {
    GET_DATA: 'GET_DATA'
  },
  actions: {
    UPDATE_DATA: 'UPDATE_DATA'
  }
}
